import { useCallback } from "react";
import localforage from "localforage";

export function useLocationLogic(API_URL, state) {
  const {
    setCurrentLocation,
    setTempLocation,
    setShowLocationModal,
    profileForm,
    form1,
  } = state;

  const requestLocation = useCallback(
    async (updateState, fromProfile) => {
      setShowLocationModal(false);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            try {
              const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?lat=${position.coords.latitude}&lon=${position.coords.longitude}&format=json`
              );
              const data = await response.json();
              const locationDetails = {
                lat: position.coords.latitude,
                long: position.coords.longitude,
                address: data.display_name,
                pincode: data.address?.postcode,
              };
              if (updateState) {
                setCurrentLocation(locationDetails);
                await localforage.setItem("LocationDetails", locationDetails);
              } else {
                const form = fromProfile ? profileForm : form1;
                form.setFieldsValue({
                  currentAddress: locationDetails.address,
                });
                setTempLocation(locationDetails);
              }
            } catch (error) {
              console.error("Error:", error);
            }
            setShowLocationModal(false);
          },
          (error) => setShowLocationModal(true),
          { enableHighAccuracy: true }
        );
      }
    },
    [form1, profileForm, setCurrentLocation, setShowLocationModal, setTempLocation]
  );

  return { requestLocation };
}
